export default __webpack_public_path__ + "static/media/BSC.d4cbb4b4.png";